/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseCompanyEmailReportUpdateRequest } from '../../models/api-response-company-email-report-update-request';
import { CompanyEmailReportUpdateRequest } from '../../models/company-email-report-update-request';

export interface UpdateCompanyEmailReport$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: CompanyEmailReportUpdateRequest
}

export function updateCompanyEmailReport(http: HttpClient, rootUrl: string, params: UpdateCompanyEmailReport$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCompanyEmailReportUpdateRequest>> {
  const rb = new RequestBuilder(rootUrl, updateCompanyEmailReport.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseCompanyEmailReportUpdateRequest>;
    })
  );
}

updateCompanyEmailReport.PATH = '/v1/api/admin-ui/company/update-email-report';
